var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from "react";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { selectUiDefinitionCategories } from "../../balancingSelectors/selectBalancingUiDefinitions";
import { IdStyles } from "../../less/IdStyles";
import { selectModalTabId } from "../../selectors/selectModalTabId";
import { selectShowMeTabId } from "../../selectors/selectShowMe";
import { actionModalTabSelect } from "../modals/actionModal";
import { ModalInfoButton } from "../modals/ModalInfoButton";
import { ModalOverlay } from "../modals/ModalOverlay";
import { Tabs } from "../tabs/Tabs";
var _MenuWrapper = function (_a) {
    var activeTabIndex = _a.activeTabIndex, tabs = _a.tabs, onTabSelect = _a.onTabSelect, onClose = _a.onClose, className = _a.className, type = _a.type, footerRenderer = _a.footerRenderer, onInfoClick = _a.onInfoClick;
    var _b = useState(activeTabIndex), tabIndex = _b[0], setTabIndex = _b[1];
    var _c = useState(undefined), currentTabId = _c[0], setCurrentTabId = _c[1];
    useEffect(function () {
        setTabIndex(activeTabIndex);
        if (tabs) {
            var tabId = tabs[activeTabIndex].id;
            if (currentTabId === tabId) {
                return;
            }
            selectTab(tabId);
        }
    }, [activeTabIndex]);
    var selectTab = function (tabId) {
        if (onTabSelect !== undefined) {
            onTabSelect(tabId);
            setCurrentTabId(tabId);
        }
    };
    var onSelect = function (index, tabId) {
        setTabIndex(index);
        selectTab(tabId);
    };
    if (!onTabSelect || !tabs || tabs.length <= 0) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(ModalOverlay, { onCloseOverride: onClose },
        React.createElement("div", { className: "modal " + IdStyles.ModalBackground + " " + className },
            React.createElement("div", { className: "modal-content" },
                React.createElement("section", { className: "modal-section" }, onTabSelect && tabs && (React.createElement(Tabs, { type: type, tabs: tabs, activeTabIndex: tabIndex, onSelect: function (index) { return onSelect(index, tabs[index].id); }, onClose: onClose }))),
                React.createElement("footer", { className: "modal-footer wooden-texture-background-flipped " + IdStyles.ModalFooter },
                    footerRenderer,
                    React.createElement(ModalInfoButton, { onClick: onInfoClick }))))));
};
var mapState = function (state, props) {
    var filterTabs = props.filterTabs, type = props.type, _a = props.activeTabIndex, activeTabIndex = _a === void 0 ? 0 : _a, lockedTabs = props.lockedTabs, customTabs = props.customTabs, modalId = props.modalId;
    var tabs = getTabs(type, customTabs, filterTabs, lockedTabs);
    var tabIndexFromState = getStateTabIndex(state, tabs, modalId);
    var finalActiveTabIndex = tabIndexFromState != undefined ? tabIndexFromState : activeTabIndex;
    return {
        activeTabIndex: finalActiveTabIndex < 0 ? 0 : finalActiveTabIndex,
        tabs: tabs,
    };
};
var getTabs = function (type, customTabs, filterTabs, lockedTabs) {
    var tabs = selectUiDefinitionCategories(type);
    if (tabs.length <= 0) {
        if (customTabs == undefined || customTabs.length <= 0) {
            return [];
        }
        tabs = customTabs;
    }
    if (filterTabs != undefined) {
        tabs = filterTabs(tabs);
    }
    if (lockedTabs) {
        tabs = tabs.map(function (tab) {
            var lockedTabIds = lockedTabs(tabs);
            if (lockedTabIds.indexOf(tab.id) !== -1) {
                return __assign({}, tab, { locked: true });
            }
            return tab;
        });
    }
    return tabs;
};
var getStateTabIndex = function (state, tabs, modalId) {
    var showMeTabId = selectShowMeTabId(state);
    var selectedModalTabId = selectModalTabId(state, modalId);
    var activeTabId = showMeTabId != undefined ? showMeTabId : selectedModalTabId;
    var foundTabIndex;
    if (activeTabId) {
        foundTabIndex = tabs.findIndex(function (tab) { return tab.id === activeTabId; });
        foundTabIndex = foundTabIndex >= 0 ? foundTabIndex : undefined;
    }
    return foundTabIndex;
};
var mapDispatch = function (dispatch) { return ({
    onTabSelect: function (tabId) { return dispatch(actionModalTabSelect(tabId)); },
}); };
export var MenuWrapper = connect(mapState, mapDispatch)(_MenuWrapper);



//////////////////
// WEBPACK FOOTER
// ./src/features/menus/MenuWrapper.tsx
// module id = 108
// module chunks = 3